import { h } from "preact";

export default function TestBanner() {
  return <div class="test-banner">
    TEST DATA - NOT FINAL - TEST DATA
  </div>
}